import { render, staticRenderFns } from "./checkoutV4.vue?vue&type=template&id=9d5a4a5e&scoped=true"
import script from "./checkoutV4.vue?vue&type=script&lang=js"
export * from "./checkoutV4.vue?vue&type=script&lang=js"
import style0 from "./checkoutV4.vue?vue&type=style&index=0&id=9d5a4a5e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d5a4a5e",
  null
  
)

export default component.exports